var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersinline = function SvgUsersinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.109 8a2.444 2.444 0 1 0 0-4.889 2.444 2.444 0 0 0 0 4.89M10.663 5.778a2.444 2.444 0 1 0 0-4.89 2.444 2.444 0 0 0 0 4.89M15.284 9.864a4.96 4.96 0 0 0-4.618-3.198c-1.26 0-2.447.492-3.342 1.316 1.648.63 3.01 1.928 3.653 3.634.1.263.144.536.161.81a11.5 11.5 0 0 0 3.17-.575c.405-.135.74-.433.925-.817.177-.373.196-.79.052-1.17M9.728 12.087a4.96 4.96 0 0 0-4.619-3.198A4.96 4.96 0 0 0 .49 12.087a1.48 1.48 0 0 0 .053 1.17c.183.384.52.681.925.817a11.5 11.5 0 0 0 7.282 0c.405-.136.741-.433.925-.817a1.48 1.48 0 0 0 .053-1.17"
  })));
};
export default SvgUsersinline;